import { Component, input } from '@angular/core';

@Component({
  selector: 'rt-options-distribution-tooltip',
  templateUrl: './options-distribution-tooltip.component.html',
  styleUrl: './options-distribution-tooltip.component.less',
})
export class OptionsDistributionTooltipComponent {
  public title = input<string | null>(null);
  public label = input.required<string>();
  public value = input.required<string | number>();
  public color = input<string>();
}
